
export class DisplayDto {
	nombre: string;
	direccion: string;
	codigo: string;
	estado: boolean;
}
